// extracted by mini-css-extract-plugin
export default {"wrapper-background":"LookUp_wrapper-background__Vvj7M","items":"LookUp_items__VZ7oS"};